// OB-6175 Update CTA design (showing with email formfill submission) on home and stream pages
function ctaDesign() {
    if (!document.body.classList.contains('single-page')) {
        const Pages = window.designCTA.ctaID;
        Object.keys(Pages).map((ids) => {
            let match = "";
            if (document.body.classList.contains('hub-page')) {
                if (ids === '3229430') {
                    match = document.querySelector(`.hub-page`);
                }
            } else if (document.body.classList.contains('listing-page')) {
                match = document.querySelector(`.stream-${ids}`);
            }
            if (match) {
                const linkCta = document.querySelectorAll('li.cta-website');
                if (linkCta) {
                    linkCta.forEach((cta) => {
                        Object.keys(Pages[ids]).map((test) => {
                            if (test === cta.dataset.ctaId) {
                                if (cta.querySelector('.subscribe-input') === null) {
                                    const bgPath = Pages[ids][test].bgPath;
                                    if (bgPath !== '' && bgPath !== undefined) {
                                        cta.style.backgroundImage = "url(" + bgPath + ")";
                                    }
                                }
                            }
                            return test;
                        });

                    });
                }
                const formCta = document.querySelectorAll('li.cta-form');
                if (formCta) {
                    formCta.forEach((cta) => {
                        Object.keys(Pages[ids]).map((test) => {
                            if (test === cta.dataset.ctaId) {
                                if (cta.querySelector('.subscribe-input') === null) {
                                    $(`#hub-cta-${test}`).trigger('click');
                                    cta.classList.add('custom-cta-design');
                                    cta.querySelector('p:not(.subscribe-input)').style.fontSize = '24px';

                                    const input = cta.querySelector('.preview-form-field');
                                    input.classList.add('focus-visible');
                                    input.focus();
                                    input.placeholder = 'yourworkemail@domain.com';

                                    const bgPath = Pages[ids][test].bgPath;
                                    if (bgPath !== '' && bgPath !== undefined) {
                                        cta.style.backgroundImage = "url(" + bgPath + ")";
                                    }
                                }
                            }
                            return test;
                        });
                    });
                }
            }
            return match;
        });
    }
}
export { ctaDesign };


// WEBPACK FOOTER //
// ./script-partials/ctaDesign.js